import { render, staticRenderFns } from "./SnapshotDistribute.vue?vue&type=template&id=e19046e0&"
import script from "./SnapshotDistribute.vue?vue&type=script&lang=js&"
export * from "./SnapshotDistribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports